import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShoppingCart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M8.4 19.041c-.663 0-1.2.533-1.2 1.19 0 .658.537 1.19 1.2 1.19.663 0 1.2-.532 1.2-1.19 0-.657-.537-1.19-1.2-1.19Zm-3.6 1.19c0-1.971 1.612-3.57 3.6-3.57s3.6 1.599 3.6 3.57c0 1.972-1.612 3.57-3.6 3.57s-3.6-1.598-3.6-3.57Zm13.2-1.19c-.663 0-1.2.533-1.2 1.19 0 .658.537 1.19 1.2 1.19.663 0 1.2-.532 1.2-1.19 0-.657-.537-1.19-1.2-1.19Zm-3.6 1.19c0-1.971 1.612-3.57 3.6-3.57s3.6 1.599 3.6 3.57c0 1.972-1.612 3.57-3.6 3.57s-3.6-1.598-3.6-3.57Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M0 1.19C0 .533.537 0 1.2 0h2.4c.587 0 1.087.42 1.184.994l.833 4.956H22.8c.348 0 .679.15.906.41.229.261.331.607.282.949l-1.2 8.33c-.011.078-.03.153-.056.227-.345.973-1 1.81-1.866 2.382a4.83 4.83 0 0 1-2.898.793H9.632a4.83 4.83 0 0 1-2.898-.793 4.766 4.766 0 0 1-1.866-2.382 1.18 1.18 0 0 1-.052-.2L3.466 7.63a1.178 1.178 0 0 1-.101-.598l-.782-4.65H1.2A1.199 1.199 0 0 1 0 1.19Zm6.017 7.14 1.148 6.833c.18.45.493.835.9 1.104.433.286.948.425 1.467.396l.068-.002H18c.023 0 .045 0 .068.002a2.41 2.41 0 0 0 1.467-.396c.403-.266.715-.647.895-1.092l.986-6.844h-15.4Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShoppingCart);
export default ForwardRef;
